

let pistasNutricion = [
    {
        "pista": "Se recomienda el consumo de entre 3 a 5 porciones de frutas y verduras al día, para reducir el riesgo de padecer sobrepeso y/o obesidad y Enfermedades Crónicas No Trasmisibles, como la diabetes, hipertensión y algunos tipos de cáncer.",
    },
    {
        "pista": "Los antioxidantes son muy importantes para el organismo porque evitan o ayudan a combatir daños que se generan en nuestras células, debidos al estrés o a factores externos como la contaminación y la mala alimentación."
    },
    {
        "pista": "El banano, el mango y la maracuyá utilizados en el batido de frutos amarillos contienen buena cantidad de fibra, vitaminas A, B y C, estos nutrientes ayudan y previenen muchas enfermedades como el cáncer de colon. ",
    },
    {
        "pista": "La fibra acompañada de una buena hidratación (tomar agua, infusiones de fruta o jugos naturales de fruta) ayuda a la salud gastrointestinal, evita obstrucciones e incluso disminuye el riesgo de cáncer de colon.",
    },
    {
        "pista": "La fibra que es un nutriente esencial para la salud intestinal, también ayuda a prevenir la obesidad, ya que su consumo genera sensación de saciedad, controlando así la ingesta a lo largo del día de otros alimentos.",
    },
    {
        "pista": "Se debe limitar el consumo de fritos porque la fritura es un método de cocción que incrementa el valor calórico o energético de las preparaciones y aumenta el riesgo de sobrepeso y obesidad. ",
    },
    {
        "pista": "Las frutas como el mango, piña, maracuyá, agraz (arándanos), y las verduras como la zanahoria, el tomate y la espinaca tienen un buen aporte de fibra que nos ayuda a mejorar la digestión y a prevenir el cáncer colon. ",
    },
    {
        "pista": "Una alternativa saludable para endulzar los jugos sin añadirle azúcar, es realizarlos con frutas dulces como el mango, la guayaba, papaya o el banano. ",
    },
    {
        "pista": "Para mantener un peso saludable, reduzca el consumo de “productos ultraprocesados o de paquete”, comidas rápidas, gaseosas y bebidas azucaradas. ",
    },
    {
        "pista": "Los alimentos se clasifican según su grado de procesamiento, allí encontramos dos clasificaciones importantes, alimentos naturales o con un mínimo procesamiento (alimentos de origen natural) y los productos ultraprocesados. Estos últimos contienen niveles excesivos de grasas saturadas, azúcares añadidos, sal y conservantes artificiales que son perjudiciales para la salud.",
    },
    {
        "pista": "El sobrepeso y la obesidad son factores de riesgo para padecer enfermedades Crónicas No Transmisibles como la diabetes, hipertensión, enfermedades cardiovasculares, del hígado y algunos tipos de canceres como el de colón.",
    },
    {
        "pista": "Las frutas y verduras son ricas en vitaminas y antioxidantes que actúan sobre las células y previenen su daño y envejecimiento, por ello previenen las enfermedades del corazón, del hígado, del cerebro, intestino y demás órganos.",
    },
    {
        "pista": "La mayoría de las frutas y verduras son fuente de fibra, que moderan la absorción de grasas y azúcares, además de reducir el estreñimiento y facilitar la evacuación intestinal, evitando el cáncer de colon.",
    },
    {
        "pista": "Los refrescos de caja y gaseosas, leches saborizadas, así como productos de paquete además de sal/sodio y grasas peligrosas –en su mayoría-, tienen sustancias para dar sabor, color, olor y textura, como si fueran naturales, pero no lo son. Generan adicción y su consumo repetido puede producir obesidad.",
    },
    {
        "pista": "El consumo de productos ultraprocesados son un factor de riesgo de deficiencias nutricionales, ya que estos alimentos aportan calorías vacías, es decir, tienen mucho aporte calórico pero son bajos en fibra, vitaminas y minerales.",
    },
];



let pistasNutricion2 = [
    {
        "pista": "Los productos comestibles listos para el consumo: procesados y altamente procesados suelen tener muchos ingredientes artificiales y aditivos, lo que puede afectar tu salud.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo son ricos en azúcares añadidos, y pueden impactar negativamente nuestro estado nutricional y de salud."
    },
    {
        "pista": "Tomar en exceso bebidas azucaradas como gaseosas, té, entre otras puede hacer que nuestro peso corporal aumente. ",
    },
    {
        "pista": "Leer las etiquetas de los alimentos te permite conocer lo que estás comiendo y hacer mejores elecciones para favorecer tu salud.",
    },
    {
        "pista": "Preparar comidas caseras con alimentos naturales es una forma de reducir el consumo de productos procesados y altamente procesados.",
    },
    {
        "pista": "Los productos procesados y altamente procesados suelen ser altos en grasas saturadas, lo que puede afectar la salud de tu corazón. ",
    },
    {
        "pista": "Los productos procesados y altamente procesados pueden llevar a problemas de salud como la obesidad. ",
    },
    {
        "pista": "Comer en exceso productos procesados y altamente procesados puede hacer que te sientas cansado y sin energía. ",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo tienen un alto contenido de sodio, lo que puede afectar la presión arterial. ",
    },
    {
        "pista": "Los productos procesados y altamente procesados a veces contienen muchos aditivos que pueden ser perjudiciales para la salud.",
    },
    {
        "pista": "Una alimentación equilibrada y basada en alimentos naturales es importante para tu crecimiento y desarrollo.",
    },
    {
        "pista": "Los productos procesados y altamente procesados suelen tener un alto contenido de calorías vacías, lo que significa que no te aportan nutrientes esenciales e importantes para mantener la salud.",
    },
    {
        "pista": "Comer en exceso productos procesados y altamente procesados puede llevar a problemas de salud como la diabetes tipo 2.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo contienen muchas grasas trans, que son perjudiciales para la salud cardiovascular.",
    },
    {
        "pista": "Los productos procesados y altamente procesados pueden tener efectos negativos en tu piel y tu cabello debido a su contenido de ingredientes artificiales.",
    },
    {
        "pista": "Consumir productos procesados y altamente procesados en exceso puede llevar a la adicción a los sabores artificiales y al azúcar.",
    },
    {
        "pista": "Los productos procesados y altamente procesados suelen contener colorantes y sabores artificiales, lo que puede afectar tu bienestar.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo tienen un alto contenido de azúcares añadidos, lo que puede contribuir al desarrollo de caries dentales.",
    },
    {
        "pista": "La calidad de los alimentos que consumes puede tener un impacto en tu concentración y rendimiento en la escuela.",
    },
    {
        "pista": "Consumir productos procesados y altamente procesados en exceso puede llevar a problemas digestivos.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo contienen aceites vegetales refinados en exceso, que pueden no ser saludables en grandes cantidades.",
    },
    {
        "pista": "Los productos procesados y altamente procesados suelen tener un alto contenido de calorías, lo que puede llevar al aumento de peso si se consumen en exceso.",
    },
    {
        "pista": "Los productos procesados y altamente procesados son más fáciles de conseguir y consumir pero pueden no ser lo mejor para tu salud a largo plazo.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo tienen un alto contenido de sodio, lo que puede llevar a la retención de líquidos.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo contienen aditivos que pueden no ser beneficiosos para tu salud.",
    },
    {
        "pista": "Los productos procesados y altamente procesados pueden generar adicción debido a su alto contenido de azúcares y sabores artificiales.",
    },
    {
        "pista": "Comer en exceso productos procesados y altamente procesados puede llevar a un aumento rápido de los niveles de azúcar en sangre, seguido de una caída brusca que puede hacer que te sientas cansado.",
    },
    {
        "pista": "Los productos procesados y altamente procesados suelen ser bajos en fibra, lo que puede afectar tu digestión.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo son altos en calorías pero bajos en nutrientes esenciales, lo que puede llevar al hambre constante.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo contienen grasas trans, que son perjudiciales para la salud cardiovascular.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a contienen ingredientes artificiales que no se encuentran en la comida casera.",
    },
    {
        "pista": "Los productos procesados y altamente procesados pueden tener un alto contenido de calorías vacías, lo que significa que no aportan nutrientes esenciales.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo son ricos en azúcares añadidos, lo que puede llevar al aumento de peso y posteriormente a enfermedades como la diabetes.",
    },
    {
        "pista": "Los productos procesados y altamente procesados pueden afectar tu salud mental debido a su impacto en el equilibrio de nutrientes y azúcares en el cuerpo.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo contienen ingredientes artificiales que pueden afectar negativamente la salud.",
    },
    {
        "pista": "Los productos procesados y altamente procesados suelen fáciles de encontrar y consumir pero pueden no ser lo mejor para tu salud a largo plazo.",
    },
    {
        "pista": "Los productos procesados y altamente procesados a menudo son ricos en azúcares añadidos, lo que puede llevar al aumento de peso y posteriormente a problemas de salud como la diabetes.",
    },
    {
        "pista": "El procesamiento de los alimentos puede afectar en mayor o menor medida las propiedades nutricionales de los alimentos naturales.",
    },
    {
        "pista": "Refinar los cereales disminuye su efecto saludable al eliminar nutrientes como la fibra, vitaminas y minerales.",
    },
    {
        "pista": "Los productos procesados y altamente procesados como los dulces, aperitivos salados y dulces, alimentos infantiles, platos combinados, sopas, salsas y aderezos comerciales, galletas, etc., presentan un potencial antioxidante significativamente menor que los alimentos frescos y crudos, como las frutas y las verduras.",
    },
    {
        "pista": "Los etiquetados frontales de los envases (EFE) han adquirido relevancia en todo el mundo y se consideran herramientas efectivas para que los consumidores sean conscientes de la calidad nutricional de los alimentos, y con ello facilitar la selección de alimentos con una mayor calidad nutricional en el momento de la compra.",
    },
    {
        "pista": "El consumo regular y excesivo de los productos comestibles procesados y altamente procesados se ha asociado a un mayor riesgo de padecer enfermedades crónicas. Además, los alimentos altamente procesados tienden a generar menos saciedad y a aumentar rápidamente los niveles de azúcar en la sangre, lo que puede aumentar el riesgo de sobrepeso, obesidad, esteatosis hepática y diabetes tipo 2.",
    },
    {
        "pista": "Los productos comestibles procesados y altamente procesados pueden ser más atractivos y apetitosos, por lo que podemos excedernos fácilmente en su consumo e incluso pueden generar adicción.",
    },
    {
        "pista": "El consumo en exceso de productos comestibles procesados y altamente procesados altos en calorías y pobres en nutrientes podría producir aumentos sostenidos en la ingesta de energía, y de este modo contribuir al aumento de peso corporal.",
    },
    {
        "pista": "Una de cada tres muertes relacionadas con el cáncer puede atribuirse a una dieta poco saludable y a un inadecuado estilo de vida.",
    },
    {
        "pista": "Un aumento del 10% en la proporción de productos comestibles procesados y altamente procesados en la dieta se asoció con un riesgo 12% mayor de padecer algún tipo de cáncer y un riesgo 11% mayor de cáncer de mama.",
    },
    {
        "pista": "Para mantener un peso saludable, reduzca el consumo de productos comestibles procesados y altamente procesados como comidas rápidas, gaseosas y bebidas azucaradas.",
    },
    {
        "pista": "Los alimentos se clasifican según su grado de procesamiento, allí encontramos dos clasificaciones importantes, alimentos naturales o con un mínimo procesamiento y productos comestibles procesados y altamente procesados. Estos últimos contienen niveles excesivos de grasas saturadas, azúcares añadidos, sal, edulcorantes o ingredientes artificiales que en exceso pueden ser perjudiciales para la salud.",
    },
    {
        "pista": "El sobrepeso y la obesidad son factores de riesgo para padecer Enfermedades Crónicas No Transmisibles como la diabetes, hipertensión, enfermedades cardiovasculares, del hígado y algunos tipos de cáncer como el de colón.",
    },
    {
        "pista": "Los refrescos y gaseosas, leches saborizadas, así como productos de paquete además de sal/sodio y grasas peligrosas –en su mayoría-, tienen sustancias para dar sabor, color, olor y textura, como si fueran naturales, pero no lo son. Pueden generar adicción y su consumo repetido puede producir obesidad.",
    },
    {
        "pista": "El consumo en exceso de productos comestibles procesados y altamente procesados es un factor de riesgo de deficiencias nutricionales, ya que estos alimentos aportan calorías vacías, es decir, tienen mucho aporte calórico, pero son bajos en fibra, vitaminas y minerales.",
    },
    {
        "pista": "El procesamiento de alimentos es necesario en ocasiones. Por ejemplo, moler el trigo es necesario para reducir el tamaño del grano y elaborar el pan. Pasteurizar la leche ayuda a eliminar bacterias que pueden afectar nuestra salud.  sin embargo, estos son procesos simples en los cuales no se adicionan ingredientes de riesgo como azúcar, sal, aceites, edulcorantes o ingredientes artificiales que deterioren la calidad nutricional de los alimentos naturales.",
    },
];



let pistasNutricion3 = [
    {
        "pista": "Las proteínas están conformadas por extensas cadenas de moléculas más pequeñas llamadas aminoácidos, las cuales cumplen funciones fundamentales en el organismo como lo son la formación de tejidos como el músculo.",
    },
    {
        "pista": "En los alimentos podemos encontrar proteínas de origen animal y de origen vegetal, las cuales, se van a absorber de manera diferente cuando las consumimos."
    },
    {
        "pista": "Los aminoácidos son fundamentales para la formación de los músculos, tendones, órganos, glándulas, uñas, pelo y sistema inmune . ",
    },
    {
        "pista": "Los aminoácidos son moléculas que se combinan para formar proteínas. Ambas son los pilares fundamentales de la vida. Cuando las proteínas se digieren o se descomponen, el resultado son los aminoácidos.",
    },
    {
        "pista": "Según las Guías Alimentarias el consumo de proteína de origen vegetal nos aporta beneficios como: prevención de la obesidad, aporte de fibra, aporte de proteínas y aporte de nutrientes esenciales.",
    },
    {
        "pista": "Los aminoácidos son moléculas que se combinan para formar proteínas. Ambas son los pilares fundamentales de la vida. Cuando las proteínas se digieren o se descomponen, el resultado son los aminoácidos. ",
    },
    {
        "pista": "Los aminoácidos podemos clasificarlos en esenciales y no esenciales. Su diferencia es que, los esenciales los obtenemos por medio de los alimentos que consumimos y los no esenciales los producimos en nuestro organismo. ",
    },
    {
        "pista": "Los aminoácidos son componentes estructurales de tejidos, células y músculos. Además, apoyan el crecimiento y reparación de tejidos y células. ",
    },
    {
        "pista": "Los alimentos de origen vegetal de mayor aporte proteico son las leguminosas, como el frijol, lentejas, garbanzos, arvejas, maní. ",
    },
    {
        "pista": "La proteína vegetal proviene de fuentes vegetales en lugar de animales.",
    },
    {
        "pista": "El tofu es un alimento preparado con la soja y es ampliamente utilizado como fuente de proteína vegetal.",
    },
    {
        "pista": "Las leguminosas son un grupo de alimentos que incluye frijoles, arvejas, lentejas y garbanzos y aportan grandes cantidades de proteína de origen vegetal.",
    },
    {
        "pista": "En Colombia, los fríjoles son un alimento que es ampliamente consumido y es una fuente rica de proteína vegetal",
    },
    {
        "pista": "Las guías alimentarias sugieren una frecuencia específica para el consumo de leguminosas de por lo menos dos veces por semana y así contribuir con un buen aporte de proteína vegetal para tu cuerpo.",
    },
    {
        "pista": "Las leguminosas son una opción rentable y económica para incorporar proteínas de origen vegetal en la dieta",
    },
    {
        "pista": "Las proteínas se encuentra en varios alimentos, no solamente en la carne y en los lácteos, sino también en las leguminosas.",
    },
    {
        "pista": "A veces las leguminosas contienen otros micronutrientes que hacen que no absorbamos debidamente la proteína que ellas nos pueden llegar a aportar. ",
    },
    {
        "pista": "En nuestros hogares podemos cocinar con calor las leguminosas para así mejorar el aporte y absorción de la proteína que estos contienen. ",
    },
    {
        "pista": "Cuando cocinamos las leguminosas mejoramos su absorción de la proteína para nuestro organismo. ",
    },
    {
        "pista": "Consumir una buena variedad de leguminosas te ayudará a obtener una mayor cantidad de proteínas. ",
    },
    {
        "pista": "La proteína de origen vegetal puede contribuir al control del colesterol LDL o también llamado colesterol malo.",
    },
    {
        "pista": "Dejar en remojo los frijoles y las lentejas de un día para otro, permite que eliminemos antinutrientes que interfieran con su aporte proteico .",
    },
    {
        "pista": "El aislado de soya, también conocido como carve, debe someterse al remojo antes de ser incluido en alguna preparación .",
    },
    {
        "pista": "El frijol es la leguminosa más importante a nivel mundial dado su alto aporte de proteínas, pudiéndose consumir verdes o secos, dependiendo de la preparación",
    },
    {
        "pista": "El garbanzo es un cultivo de leguminosas muy nutritivo y constituye una de las fuentes más baratas de proteína que podemos encontrar en el mercado.",
    },
    {
        "pista": "Las proteínas de origen vegetal son muy económicas y pueden ser la mejor opción para los hogares con muchos integrantes.",
    },
    {
        "pista": "Las proteínas de origen vegetal como los frutos secos, las lentejas, los frijoles y los garbanzos, resultan ser alternativas para reemplazar la proteína de origen animal. ",
    },
    {
        "pista": "Las leguminosas no solo nos aportan proteína, también nos dan fibra que contribuye a la prevención de enfermedades como el cáncer de colon. ",
    },
    {
        "pista": "Diferentes culturas donde el consumo de proteína de origen animal ha sido de difícil acceso, han encontrado en las leguminosas la manera de obtener proteína de muy buena calidad. ",
    },
    {
        "pista": "Las características que más llaman la atención de las leguminosas, es que aparte de ser fuente de proteínas, son muy económicas y exequibles. ",
    },
    {
        "pista": "Las leguminosas no solo nos aportan proteína de excelente calidad, sino que también nos aportan vitaminas, minerales y fibra.",
    },
    {
        "pista": "Las leguminosas nos aportan fibra, proteína y micronutrientes.",
    },
    {
        "pista": "Combinar las leguminosas con alimentos como los cereales aumenta el aporte y la absorción de la proteína en nuestro organismo.",
    },
    {
        "pista": "En la cultura colombiana un buen hábito es combinar las leguminosas con cereales, ya que mejoran la absorción de la proteína en el organismo.",
    },
    {
        "pista": "Las leguminosas se pueden almacenar por lagos periodos de tiempo sin llegar a descomponerse, ya que son alimentos con muy bajo grado de humedad y las consumimos secas.",
    },
    {
        "pista": "El carve es proteína aislada de soya, una de las mejores fuentes de proteína vegetal cuando se usa combinado con cereales.",
    },
    {
        "pista": "El plato saludable recomendado para Colombia sugiere el consumo de leguminosas. ",
    },
    {
        "pista": "La producción de alimentos como las leguminosas son más amigables con el medio ambiente que la producción de carne . ",
    },
    {
        "pista": "La proteína de soya contiene todos los aminoácidos esenciales requeridos en nuestra alimentación. ",
    },
    {
        "pista": "El uso de las leguminosas en la cocina no solo permite una gran variedad de preparaciones, sino que resulta una opción muy económica y saludable. ",
    },
    {
        "pista": "Producir proteína vegetal es mucho más económica que la producción de proteína animal.",
    },
    {
        "pista": "A las familias se les podría recomendar aumentar el consumo de leguminosas ya que son más económicas y podríamos garantizar un aporte significativo de proteína.",
    },
    {
        "pista": "Cuando no se puede acceder a proteína de origen animal porque es costosa, podemos encontrar como alternativa las proteínas de origen vegetal y así garantizar el consumo de proteína.",
    },
    {
        "pista": "La proteína de soya purificada es totalmente disponible para el organismo, sin embargo, en la naturaleza no se presenta de esta forma, por esto el carve resulta una muy buena opción de obtenerla.",
    },
    {
        "pista": "El hummus de garbanzos es un plato ampliamente conocido y de muy bajo costo de elaboración.",
    },
    {
        "pista": "Las legumbres se consumen en todo el planeta, empleándose en guisos, harinas, purés, guarniciones, aperitivos o postres. Son una fuente rica de proteínas y aminoácidos esenciales que sirve de complemento perfecto a los cereales.",
    },
    {
        "pista": "La soya es la fuente más abundante y valiosa de proteínas vegetales, ya que además de ser de gran calidad, cuenta con un adecuado contenido de aminoácidos esenciales.",
    },
    {
        "pista": "Independientemente de su valor nutrimental, se ha descrito que la proteína de soya reduce las concentraciones de colesterol sanguíneo.",
    },
    {
        "pista": "Es indispensable aplicar un tratamiento térmico durante el procesamiento del grano, lo que permite una mejor utilización de dicha proteína por parte del organismo. ",
    },
    {
        "pista": "Al combinarse el consumo de leguminosas con un cereal, se genera una proteína tan completa como la de origen animal. ",
    },
    {
        "pista": "Las proteínas de origen vegetal tienen aplicaciones importantes en la industria alimenticia como lo es la panadería.",
    },
];



let pistasNutricion4 = [
    {
        "pista": "Los antioxidantes son sustancias químicas que ayudan al cuerpo del ser humano a impedir la oxidación celular, se podría decir, que la oxidación celular en el envejecimiento de la célula.",
    },
    {
        "pista": "En una dieta variada y balanceada las frutas y las verduras son los alimentos que más aportan antioxidantes, mejorando la salud celular."
    },
    {
        "pista": "Según las Guías alimentarias de Colombia, las frutas y las verduras se deben de incluir como mínimo cinco veces al día (Una porción en cada comida), así se garantiza el aporte suficiente de los nutrientes para el adecuado desarrollo del cuerpo. ",
    },
    {
        "pista": "Se recomienda consumir las frutas y las verduras con cáscara (cuando se pueda), así garantizamos un mayor aporte de fibra para el organismo y mejoramos la salud digestiva.",
    },
    {
        "pista": "Consumir mínimo cinco frutas y verduras al día está  asociado a la prevención de enfermedades del miocardio y accidentes cerebro vasculares."
    },
    {
        "pista": "El consumo de antioxidantes está asociado a la prevención de enfermedades como el cáncer, el Alzheimer y enfermedades crónicas, ya que evitan la oxidación de las celulas. ",
    },
    {
        "pista": "El consumo de frutas y verduras disminuye los niveles de adiposidad en el cuerpo, por ende, favorece a la reducción del sobrepeso y la obesidad, debido a que aporta fibra y favorece  la disminución de la densidad energética de la dieta.",
    },
    {
        "pista": "Para que los nutrientes y las sustancias antioxidantes de las frutas  y verduras sean absorbidas y aprovechadas por el organismo, se recomienda consumirlas preferiblemente crudas."
    },
    {
        "pista": "Una de las estrategias educativas en alimentación y nutrición es fomentar el consumo de frutas y verduras con la máxima variedad de colores posibles, así se garantiza el aporte de múltiples nutrientes. ",
    },
    {
        "pista": "Las frutas y verduras de color verde, son ricas en vitamina C y antioxidantes, promoviendo el funcionamiento celular y disminuyendo la oxidación de las mismas, previniendo el envejecimiento celular."
    },
    {
        "pista": "La vitamina C aporta muchos antioxidantes ayudando al crecimiento y reparación de los tejidos celulares, bloqueando el daño de los radicales libres. ",
    },
    {
        "pista": "Existen moléculas llamadas radicales libres que se producen cada día en nuestro organismo como  resultado de las reacciones biológicas. Estás moléculas son necesarias para el organismo, sin embargo, se debe de controlar su producción ya que pueden tener efectos negativos.",
    },
    {
        "pista": "Los antioxidantes son sustancias encargadas de neutralizar a los radicales libres y protegernos frente a su acción dañina sobre las células."
    },
    {
        "pista": "Las frutas y verduras de color amarillo o naranja continen muchos compuestos como los betacarotenos que son antioxidantes  y son ricos en vitamina A. ",
    },
    {
        "pista": "Los betacarotenos y la vitamina A ayudan principalmente a preservar la salud visual y al funcionamiento del sistema inmune gracias a su capacidad antioxidante."
    },
    {
        "pista": "La vitamina A favorece la salud visual, lo que nos ayuda con la visión nocturna. ",
    },
    {
        "pista": "Los antioxidantes que aportan los betacarotenos nos ayudan a prevenir el envejecimiento de la piel, además, tienen efecto antiinflamatorio favoreciendo la recuperación.",
    },
    {
        "pista": "Se aconseja que todas las verduras fuentes de antioxidantes se consuman crudas para aprovechar al máximo sus nutrientes, ya que el calor puede destruir su valor nutricional o por lo menos, someterlas al calor por tiempos mínimos."
    },
    {
        "pista": "Las frutas y verduras de color morado contienen flavonoides, el cual, es un antioxidante y ayudan al fortalecimiento de la memoria. ",
    },
    {
        "pista": "Colombia tiene gran variedad de frutas y verduras, todas son fuentes de antioxidantes y tiene características según su color."
    },
    {
        "pista": "La industria vende suplementos de antioxidantes, sin embargo, estos pueden superar las dosis permitidas para el cuerpo humano y ser perjudiciales para la salud, se recomienda consumir sólo las fuentes naturales. ",
    },
    {
        "pista": "Una de las estrategias para asegurar el consumo de frutas y verduras durante el día, es conseguir aquellas que están en cosecha, así las conseguirás más económicas.",
    },
    {
        "pista": "Las  verduras tienen múltiples formas de preparar, sin embargo, se recomienda comerlas en las ensaladas para evitar que sean sometidas a tiempos prolongados de cocción con calor, para no dañar su valor nutricional."
    },
    {
        "pista": "El antioxidante en las frutas cítricas como las naranjas es bien conocido por sus beneficios para la salud. ",
    },
    {
        "pista": "El beta-caroteno es conocido por mejorar la salud visual y se encuentra en una verdura específica."
    },
    {
        "pista": "Los antioxidantes tienen un papel importante en la protección de tus células. ",
    },
    {
        "pista": "Los antioxidantes tienen efectos positivos en la función cerebral.",
    },
    {
        "pista": "Algunas frutas son particularmente ricas en antioxidantes."
    },
    {
        "pista": "Los antioxidantes desempeñan un papel clave en la salud. ",
    },
    {
        "pista": "Algunas vitaminas son conocidas por mejorar la salud de la piel."
    },
    {
        "pista": "La fibra tiene un impacto positivo en la salud. ",
    },
    {
        "pista": "Los antioxidantes tienen un papel en la prevención de enfermedades como el cáncer.",
    },
    {
        "pista": "Los principales antioxidantes solo vienen de los alimentos fuente del reino vegetal.."
    },
    {
        "pista": "Mantén tu piel radiante y llena de vida comiendo frutas y verduras repletas de antioxidantes, como la vitamina C. ",
    },
    {
        "pista": "¿Quieres cuidar tus ojos? Come zanahorias, tomates y ahuyama; sus antioxidantes protegerán tu visión."
    },
    {
        "pista": "¡El poder antioxidante de las frutas y verduras puede mantener tu corazón fuerte y saludable a lo largo de tu vida!",
    },
    {
        "pista": "La fibra que encuentras en frutas y verduras ayuda a tu digestión y a mantener un peso saludable.",
    },
    {
        "pista": "Los antioxidantes combaten la inflamación y previenen las enfermedades como la artritis al incluir frutas y verduras en tu dieta diaria."
    },
    {
        "pista": "Cuando consumas fibra, se debe de consumir también agua y así ayudar al sistema digestivo. ",
    },
    {
        "pista": "Si tienes diabetes, las frutas y verduras antioxidantes pueden ser aliados para mantener estables tus niveles de azúcar en sangre, por su aporte de fibra."
    },
    {
        "pista": "Aliméntate para potenciar tu mente. Los antioxidantes en frutas y verduras pueden mejorar tu función cognitiva. Ayuda a tu cuerpo a desintoxicarse naturalmente con la ayuda de los antioxidantes presentes en estos alimentos. ",
    },
    {
        "pista": "Protege tu salud frente al cáncer. Los antioxidantes, como los flavonoides en las frutas y verduras, son excelentes defensores.",
    },
    {
        "pista": 'Los antioxidantes en frutas y verduras son como "reparadores" del ADN, evitando daños y mutaciones celulares.'
    },
    {
        "pista": "Mantén una buena salud pulmonar y reduce el riesgo de enfermedades respiratorias con estos alimentos antioxidantes. ",
    },
    {
        "pista": "El bajo consumo de agua evita que la fibra ayude a la digestión y no se absorben los antioxidantes. ",
    },
    {
        "pista": "Todos los órganos del cuerpo se benefician de los antioxidantes."
    },
    {
        "pista": "Las frutas y verduras proporcionan muchos nutrientes benéficos, incluyendo vitaminas, minerales, grasas sanas, proteína, calcio, fibra, antioxidantes y fitonutrientes. ",
    },
    {
        "pista": "Lo que hacen los antioxidantes es frenar las reacciones de oxidación en las células a partir de las cuales se originan los nocivos radicales libres.",
    },
    {
        "pista": "Si usted tiene diabetes o prediabetes, la fibra es su amiga porque ayuda a controlar el azúcar en la sangre y a manejar el peso."
    },
    {
        "pista": "El betacaroteno es un pigmento orgánico de color rojo anaranjado fuerte abundante en hongos, plantas y frutas. ",
    },
    {
        "pista": "La fibra se clasifica comúnmente como soluble, que se disuelve en agua."
    },
    {
        "pista": "Las frutas y verduras en cosecha salen más baratas. ",
    },
];

export { pistasNutricion, pistasNutricion2, pistasNutricion3, pistasNutricion4 };